import {CheckIcon, XIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'

import {CircleProgressBar} from './CircleProgressBar'
import styles from './InlineEditActions.module.css'

interface InlineEditActionsProps {
  onSave: () => void
  onCancel: () => void
  value: string
  maxLength?: number | null
}

export function InlineEditActions({value, maxLength, onSave, onCancel}: InlineEditActionsProps) {
  const showCharacterCount = Boolean(maxLength && maxLength > 0)
  const tooLong = showCharacterCount && value.length > (maxLength || 0)

  return (
    <div className={styles.actionButtons}>
      {showCharacterCount && (
        <>
          <CharacterCountStatus text={value} promptCharLimit={maxLength || 0} />
          <Line />
        </>
      )}
      <IconButton
        className={styles.cancelButton}
        variant="invisible"
        icon={XIcon}
        aria-label="Cancel"
        size="small"
        onClick={onCancel}
      />
      <IconButton
        className={styles.saveButton}
        variant="invisible"
        icon={CheckIcon}
        aria-label="Save"
        disabled={tooLong}
        size="small"
        onClick={onSave}
      />
    </div>
  )
}

export const Line = () => <div className={styles.line} />

export function CharacterCountStatus({text, promptCharLimit}: {text: string; promptCharLimit: number}) {
  return (
    <div className={styles.characterCountStatus}>
      <CircleProgressBar value={(text.length / promptCharLimit) * 100} />
      <span className={styles.characterCountText}>{(promptCharLimit - text.length).toLocaleString()}</span>
    </div>
  )
}
